import { ArrowCircleRight } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, IconButton } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import { MaterialReactTable } from 'material-react-table';
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt';
import { Link, Route, Routes } from 'react-router-dom';
import userStore from 'store/userStore';
import Komponen from './Komponen';

const LaporanPendapatan = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            {/* <Route path="rincian-belanja" element={<RincianBelanja />} /> */}
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [loading, setLoading] = useState(false)

    const [listPendapatan, setListPendapatan] = useState([])

    const reqPendapatan = () => {
        addReq()
        postDataWithResponse(
            '/admin-opd/get-tr-pendapatan',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setListPendapatan(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqPendapatan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            accessorKey: 'kode',
            header: 'Rekening',
            Cell: ({ cell }) => (
                <Box>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                </Box>
            )
        },
        {
            accessorKey: 'uraian',
            header: 'Uraian',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    // fontWeight={(cell.row.original.status === 'Program' || cell.row.original.status === 'Kegiatan') === 'Program' && 'bold'}
                    variant="inherit"
                    fontSize="small"
                    color={cell.row.original.ket === 'notequal' ? 'error' : 'inherit'}
                >
                    {
                        parseInt(cell.getValue()) === 0 ? ' ' : parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <ArgonBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                        <ArgonTypography variant="h6">Tabel Laporan Pendapatan</ArgonTypography>
                    </ArgonBox>
                    <ArgonBox
                        sx={{
                            "& .MuiTableRow-root:not(:last-child)": {
                                "& td": {
                                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                        `${borderWidth[1]} solid ${borderColor}`,
                                },
                            },
                        }}
                    >
                        <MaterialReactTable
                            columns={columns}
                            data={listPendapatan}
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={false}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='first'
                            renderRowActions={({ row, table }) => (
                                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                                    <IconButton
                                        color="info"
                                        component={Link}
                                        to='/a-pd/laporan-pendapatan/komponen'
                                        state={row.original.id}
                                    >
                                        <ArrowCircleRight fontSize='small' />
                                    </IconButton>
                                </Box>
                            )}
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Aksi', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'center'
                                },
                            }}
                        />
                    </ArgonBox>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default LaporanPendapatan